export default __webpack_public_path__ + "static/media/MFZ-portfolio.1b30df96.png";